import { Injectable } from '@angular/core'
import { Subject } from 'rxjs'
import { PurchasedErrorType } from '../types/purchased-track.type'

@Injectable({
  providedIn: 'root'
})
export class PurchasesPopupService {
  $showPurchasesPopupSubj = new Subject<PurchasedErrorType>()

  constructor() {}

  notify(error: PurchasedErrorType) {
    this.$showPurchasesPopupSubj.next(error)
  }
}
